import { ZapierFields } from '../../components/FieldsContainer';

const getDuplicateKeys = (fields: ZapierFields): Array<string> => {
  const keys = fields.map(field => field.key);

  return keys.filter((key, index) => keys.indexOf(key) != index);
};

export default getDuplicateKeys;
